import type { User } from '@supabase/supabase-js';

/**
 * Buyer-type sessions are recognized by the metadata buyer-register stamps on
 * the auth user at creation (account_id + source='public_register' via
 * generateLink) — staff users are invited through admin-manage-users, whose
 * metadata carries only full_name (#2529). The check is synchronous (no role
 * lookup) so the staff hot path never waits on a query. Buyers whose auth
 * user predates the metadata stamp read as staff and keep the classic
 * /dashboard — exactly the pre-#2530 behavior, no regression.
 */
export function isBuyerSession(user: User | null | undefined): boolean {
  const meta = (user?.user_metadata ?? {}) as Record<string, unknown>;
  return Boolean(meta.account_id) || meta.source === 'public_register';
}
